var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCghBase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4034_45283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#9999FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3359 9.34668C19.6526 9.34799 19.9251 9.57228 19.9873 9.88282C20.2887 11.3893 21.2012 12.8535 22.417 13.8262C23.8691 14.988 24.6661 16.4315 24.667 18.0107L24.6641 18.208C24.6316 19.1924 24.326 20.1497 23.7803 20.9727C23.198 21.8506 22.3677 22.5366 21.3955 22.9424C20.4233 23.348 19.3519 23.4555 18.3184 23.252C17.2848 23.0483 16.3346 22.5429 15.5889 21.7988C15.3283 21.5388 15.3279 21.1161 15.5879 20.8555C15.8478 20.5952 16.2697 20.5949 16.5303 20.8545C17.0892 21.4121 17.8016 21.7918 18.5762 21.9443C19.3507 22.0969 20.1533 22.0159 20.8818 21.7119C21.6103 21.4079 22.2326 20.8941 22.6689 20.2363C23.1052 19.5785 23.3363 18.805 23.333 18.0156V18.0137C23.333 16.9274 22.7966 15.8381 21.583 14.8672C20.6504 14.121 19.8691 13.1359 19.332 12.043C19.2126 12.2857 19.0824 12.5239 18.9385 12.7539C18.7431 13.0659 18.3316 13.1602 18.0195 12.9648C17.7078 12.7696 17.6129 12.3588 17.8076 12.0469C18.2243 11.3811 18.5203 10.6459 18.6807 9.87696L18.6953 9.82032C18.7799 9.54059 19.0391 9.34552 19.3359 9.34668ZM14.667 10.8672C14.9845 10.8673 15.2579 11.091 15.3203 11.4023C15.4819 12.21 15.9685 12.9965 16.6143 13.5234C17.4933 14.2406 18 15.151 18 16.167C17.9998 18.0063 16.5102 19.533 14.667 19.5332C12.8237 19.5332 11.3332 18.0064 11.333 16.167C11.333 15.163 11.8282 14.2359 12.7236 13.5195C13.3684 13.0037 13.8503 12.2144 14.0127 11.4023L14.0273 11.3457C14.1099 11.0643 14.369 10.8672 14.667 10.8672ZM14.668 13.2949C14.3689 13.778 13.9919 14.2123 13.5566 14.5606C12.9188 15.0709 12.667 15.6377 12.667 16.167C12.6672 17.2873 13.5772 18.2002 14.667 18.2002C15.7566 18.2 16.6668 17.2872 16.667 16.167C16.667 15.6364 16.4131 15.0794 15.7725 14.5566C15.3444 14.2075 14.9674 13.776 14.668 13.2949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4034_45283",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4034_45283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4034_45283",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCghBase);
export default __webpack_public_path__ + "static/media/CGH_Base.5c049fc27537a10466a412a03478d0c3.svg";
export { ForwardRef as ReactComponent };